import { heightPropsNames } from './height';
import { marginPropsNames } from './margin';
import { paddingPropsNames } from './padding';
import { widthPropsNames } from './width';
const invalidProps = [
    ...marginPropsNames,
    ...paddingPropsNames,
    ...widthPropsNames,
    ...heightPropsNames,
    'display',
    'flexDirection',
    'alignItems',
    'alignSelf',
    'justifyContent',
    'gap',
    'borderRadius',
    'background',
    'backgroundColor',
];
export const shouldForwardProp = (prop) => !invalidProps.includes(prop);
